import { Input } from '@api/Inputs/Input';
import InputServ from '@api/Inputs/InputServ';

class InputsService {
    saveInput = (input: Input): Promise<Input> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await InputServ.saveInput(input);
                resolve(data);
            } catch (error) {
                reject('Error saving input: ' + error);
            }
        });
    };
    getInputs = (): Promise<Input[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await InputServ.getInputs();
                resolve(data);
            } catch (error) {
                reject('Error getting inputs: ' + error);
            }
        });
    };
    getInput = (inputId: string): Promise<Input> => {
        return new Promise(async (resolve, reject) => {
            try {
                const Input = await InputServ.getInput(inputId);
                resolve(Input);
            } catch (error) {
                reject('Error getting input: ' + error);
            }
        });
    };

    deleteInput = (inputId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await InputServ.deleteInput(inputId);
                resolve();
            } catch (error) {
                reject('Error deleting input: ' + error);
            }
        });
    };
}
export default InputsService;
